export default {
  PENDING: 0,
  PAID: 1,
  ERROR: 2,
};
